import { render, staticRenderFns } from "./StatusSwitch.vue?vue&type=template&id=621123ab&scoped=true&lang=pug"
import script from "./StatusSwitch.vue?vue&type=script&lang=ts"
export * from "./StatusSwitch.vue?vue&type=script&lang=ts"
import style0 from "./StatusSwitch.vue?vue&type=style&index=0&id=621123ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621123ab",
  null
  
)

export default component.exports